// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hp","advertDetailParameterList__header":"c-n_hq","advertDetailParameterList__list":"c-n_hr"};